import React from "react";

function AppDetailsStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="pt-3 mt-3">
          <h2 className="h6 pb-1 mb-3 color_grey">
            Great! Please Select Your Requirements for the Mobile Application.
          </h2>
        </div>

        <div className="col-lg-12">
          <label className="form-label">
            <span className="req__area">*</span> Application Platform
          </label>
          {/* Required Field: Must choose one. */}
          <div className="nav nav-pills row row-cols-2 row-cols-sm-3 row-cols-md-3 gap-0 g-3 mb-4">
            {[
              { id: "ios", label: "iOS", icon: "/assets/icons/apple.svg" },
              {
                id: "android",
                label: "Android",
                icon: "/assets/icons/playstore.svg",
              },
            ].map((platform) => (
              <div
                className="col"
                style={{ maxWidth: "150px" }}
                key={platform.id}
              >
                <input
                  type="checkbox"
                  className="btn-check"
                  id={platform.id}
                  name={platform.id}
                  onChange={handleChange}
                  checked={formData[platform.id] || false}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor={platform.id}
                >
                  <img
                    className="type__icon"
                    src={platform.icon}
                    style={{ maxWidth: "35px" }}
                    alt={platform.label}
                  ></img>
                  {platform.label}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="col-lg-12">
          <div className="row row-cols-1 row-cols-sm-1 g-3 g-sm-4 pb-3 pb-sm-4 mb-xl-2">
            {/* Similarity */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Which Application is Yours
                Similar To?
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="app-similarity"
                onChange={handleChange}
                value={formData["app-similarity"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                {[
                  "Messaging and Communication Apps: WhatsApp, Telegram, Signal",
                  "Social Media Platforms: Instagram, Twitter, Facebook",
                  "E-Commerce and Shopping Apps: Amazon, eBay, Shopify",
                  "Maps and Navigation Apps: Uber, Google Maps",
                  "Food Delivery Apps: Uber Eats, DoorDash, Grubhub",
                  "Health and Fitness Apps: MyFitnessPal, Fitbit, Nike Training Club",
                  "Education and Learning Apps: Duolingo, Udemy, Coursera",
                  "Productivity and Task Management Apps: Trello, Asana, Notion",
                  "News and Information Apps: Flipboard, BBC News, NY Times",
                  "Travel, Hotel, Booking, and Listing Apps: Booking.com, Airbnb, Expedia",
                  "Job Listing and Career Apps: LinkedIn, Indeed, Glassdoor",
                  "Stock and Investment Apps: Robinhood, eToro",
                  "Smart Home Control Apps: Google Home, Philips Hue",
                  "Other",
                ].map((option) => (
                  <option value={option} key={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            {/* Infrastructure */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Application Infrastructure
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="app-platform"
                onChange={handleChange}
                value={formData["app-platform"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                {[
                  "React Native",
                  "Flutter",
                  "Native",
                  "Web App",
                  "Not sure.",
                ].map((option) => (
                  <option value={option} key={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Extra Options */}
          <div className="row">
            <div className="col-lg-12">
              <label className="form-label">Extra Options</label>
            </div>
            <div className="col-lg-12">
              <div className="row row-cols-1 row-cols-md-1 gy-3 gx-4">
                {[
                  { id: "push-notify", label: "Push Notifications" },
                  { id: "qr-scanner", label: "Barcode / QR Scanning" },
                  { id: "sms-verify", label: "SMS (Number Verification)" },
                  { id: "health-data", label: "Health Data" },
                  {
                    id: "gyroscope",
                    label: "Device Sensors (Gyroscope, etc.)",
                  },
                  { id: "app-big-media", label: "Large Media / File Upload" },
                  { id: "app-booking", label: "Reservation / Booking" },
                  { id: "app-chat", label: "Messaging / Chat" },
                  { id: "app-payment", label: "Payment Infrastructure" },
                ].map((option) => (
                  <div className="col" key={option.id}>
                    <div className="form-check mb-0">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={option.id}
                        name="extra-options"
                        onChange={handleChange}
                        checked={
                          formData["extra-options"]?.includes(option.label) ||
                          false
                        }
                        value={option.label}
                      />
                      <label htmlFor={option.id} className="form-check-label">
                        {option.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AppDetailsStep;
